(() => {
  if (window.nxtCartSupportBound) return;
  window.nxtCartSupportBound = true;

  const drawer = document.querySelector('cart-drawer');
  const optOutKey = 'nxt-delivery-support-opt-out';
  let pending = false;
  const jsonCartEndpoint = (url) => (url.endsWith('.js') ? url : `${url}.js`);

  const currentPanel = () => {
    if (drawer?.classList.contains('active')) {
      return drawer.querySelector('[data-nxt-support]');
    }
    return document.querySelector('[data-nxt-support-page]');
  };

  const updateSupport = async (add, panel) => {
    const variantId = panel?.dataset.variantId;
    if (pending || !variantId) return;
    pending = true;
    const onCartPage = panel.hasAttribute('data-nxt-support-page');
    const lineKey = panel.dataset.lineKey;
    const payload = add
      ? { items: [{ id: Number(variantId), quantity: 1 }] }
      : { id: lineKey || String(variantId), quantity: 0 };
    if (!onCartPage) {
      // Shopify's JSON Cart API expects a comma-separated section ID string.
      // Passing an array can return null section HTML, which makes the drawer
      // refresh fail even though the support item was updated successfully.
      payload.sections = 'cart-drawer,cart-icon-bubble';
      payload.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch(jsonCartEndpoint(add ? routes.cart_add_url : routes.cart_change_url), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || 'support_update_failed');
      if (onCartPage) {
        window.location.reload();
      } else {
        drawer.renderContents(cart);
      }
    } catch (error) {
      console.error('NXTLVL support update failed:', error);
      sessionStorage.setItem(optOutKey, add ? '1' : '0');
      const box = panel.querySelector('[data-nxt-support-check]');
      if (box) box.checked = !add;
      panel.dataset.nxtSupportError = 'true';
      let message = panel.querySelector('[data-nxt-support-error]');
      if (!message) {
        message = document.createElement('p');
        message.dataset.nxtSupportError = '';
        message.setAttribute('role', 'alert');
        panel.append(message);
      }
      message.textContent = '更新できませんでした。もう一度お試しください。';
    } finally {
      pending = false;
    }
  };

  const synchronize = () => {
    if (pending) return;
    const panel = currentPanel();
    if (!panel || panel.dataset.nxtSupportError === 'true') return;
    const optedOut = sessionStorage.getItem(optOutKey) === '1';
    const hasMerchandise = panel.dataset.hasMerchandise === 'true';
    const inCart = panel.dataset.inCart === 'true';
    const checkbox = panel.querySelector('[data-nxt-support-check]');
    if (checkbox) checkbox.checked = hasMerchandise && !optedOut;

    if (!hasMerchandise && inCart) updateSupport(false, panel);
    else if (hasMerchandise && !optedOut && !inCart) updateSupport(true, panel);
    else if (hasMerchandise && optedOut && inCart) updateSupport(false, panel);
  };

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('[data-nxt-support-check]');
    if (!checkbox) return;
    event.stopPropagation();
    const panel = checkbox.closest('[data-nxt-support]');
    if (!panel) return;
    if (checkbox.checked) sessionStorage.removeItem(optOutKey);
    else sessionStorage.setItem(optOutKey, '1');
    delete panel.dataset.nxtSupportError;
    panel.querySelector('[data-nxt-support-error]')?.remove();
    updateSupport(checkbox.checked, panel);
  }, true);

  if (drawer) {
    new MutationObserver(synchronize).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
  }
  synchronize();
})();
